import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const PHOTOSHOOT_SESSION_TIMEZONE = 'Europe/Berlin';

/** Maps a timestamp to the photoshoot session date (YYYY-MM-DD). Day boundary: 06:35 Europe/Berlin. */
export function getPhotoShootSessionDate(input) {
    const berlin = input ? dayjs(input).tz(PHOTOSHOOT_SESSION_TIMEZONE) : dayjs().tz(PHOTOSHOOT_SESSION_TIMEZONE);
    const cutoff = berlin.startOf('day').hour(6).minute(35).second(0).millisecond(0);
    const sessionDay = berlin.isBefore(cutoff) ? berlin.subtract(1, 'day') : berlin;
    return sessionDay.format('YYYY-MM-DD');
}

/** Resolves selected or current value to a session date query param. */
export function resolvePhotoShootSessionDateQuery(dateInput) {
    if (dateInput == null || dateInput === '') {
        return getPhotoShootSessionDate();
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(String(dateInput))) {
        return String(dateInput);
    }
    return getPhotoShootSessionDate(dateInput);
}
